import React, { useState, useContext, useEffect } from "react";

import {
  Grid,
  Button,
  Typography,
  TextField,
  IconButton,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableFooter,
  TableRow,
  TableCell,
  TablePagination,
  TableSortLabel,
} from "@material-ui/core";

import PropTypes from "prop-types";
import moment from "moment";

import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

import { makeStyles, useTheme } from "@material-ui/core/styles";

// import LayoutContext from "../../context/layout/LayoutContext";
import LogsContext from "../../context/logs/LogsContext";
import LogsRow from "./LogsRow";

const LogsHome = () => {
  const { getLogs, logs } = useContext(LogsContext);
  // const { setAlert } = useContext(LayoutContext);
  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState("");
  const [page, setPage] = useState(0);
  const [disableUpdate, setDisableUpdate] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState([
    10, 25, 50, 100,
  ]);
  const rowHeight = 45;
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paginationRoot: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),
    },
    tableHeader1: {
      backgroundColor: theme.palette.primary.dark,
      fontWeight: "200",
    },
    tabelCell1: {
      color: theme.palette.primary.contrastText,
    },
    iconButtonStyle: {
      "&:focus": {
        outline: "none",
      },
    },
    buttonStyle: {
      "&:focus": {
        outline: "none",
      },
      width: 110,
    },
  }));

  const classes = useStyles();
  const theme = useTheme();

  useEffect(() => {
    getLogs();
  }, []);

  useEffect(() => {
    if (logs) {
      setRows(logs);
      let rowsOptions = [];
      let index = false;
      for (let x in rowsPerPageOptions) {
        if (rowsPerPageOptions[x] < logs.length) {
          rowsOptions.push(rowsPerPageOptions[x]);
        } else {
          index = true;
        }
      }
      if (index && logs.length > 0) {
        rowsOptions.push({
          value: logs.length,
          label: "All",
        });
      }
      setRowsPerPageOptions(rowsOptions);
    }
  }, [logs]);

  // useEffect(() => {
  //   if (error) {
  //     setAlert(error, "error");
  //   }
  // }, [error]);

  // useEffect(() => {
  //   if (returnedData) {
  //     if (returnedData.success) {
  //       getFacebook();
  //     }
  //     if (returnedData.updated) {
  //       getFacebook();
  //       setAlert("Update in progress", "warning");
  //     }
  //   }
  // }, [returnedData]);

  useEffect(() => {
    if (searchValue) {
      let matched_logs = [];
      for (let x in logs) {
        if (
          (logs[x].created_at &&
            logs[x].created_at
              .toLowerCase()
              .includes(searchValue.toLowerCase())) ||
          (logs[x].user &&
            logs[x].user.toLowerCase().includes(searchValue.toLowerCase())) ||
          (logs[x].description &&
            logs[x].description
              .toLowerCase()
              .includes(searchValue.toLowerCase()))
        ) {
          matched_logs.push(logs[x]);
        }
      }
      setRows(matched_logs);
    } else {
      if (logs) {
        setRows(logs);
      }
    }
  }, [searchValue]);

  function TablePaginationActions(props) {
    const classes = useStyles();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
      onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.paginationRoot}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
          className={classes.iconButtonStyle}
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}{" "}
        </IconButton>{" "}
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
          className={classes.iconButtonStyle}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}{" "}
        </IconButton>{" "}
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
          className={classes.iconButtonStyle}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}{" "}
        </IconButton>{" "}
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
          className={classes.iconButtonStyle}
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}{" "}
        </IconButton>{" "}
      </div>
    );
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSearchValue("");
    setOpen("");
  };

  const handleChangeRowsPerPage = (event) => {
    setSearchValue("");
    setOpen("");
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (page !== 0) {
      setPage(0);
    }
    if (open !== "") {
      setOpen("");
    }
    setSearchValue(e.target.value);
  };

  const [displayRows, setDisplayRows] = useState([]);

  useEffect(() => {
    setDisplayRows(
      rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    );
  }, [rows, page, rowsPerPage]);

  return (
    <div className={classes.root}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <Grid container spacing={0} justifyContent="space-between">
            <Grid item>
              <Typography variant="h4"> Logs </Typography>{" "}
            </Grid>{" "}
            <Grid item>
              <Grid container direction="row" spacing={3} alignItems="flex-end">
                <Grid item>
                  <TextField
                    label="Search"
                    size="small"
                    value={searchValue}
                    onChange={onSearch}
                    style={{
                      width: 200,
                    }}
                    fullWidth
                    InputProps={{
                      autoComplete: "off",
                    }}
                  />{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>{" "}
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table
              className={classes.table}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow className={classes.tableHeader1}>
                  <TableCell
                    style={{
                      width: "4%",
                    }}
                  />{" "}
                  <TableCell
                    align="left"
                    className={classes.tabelCell1}
                    style={{
                      width: "20%",
                    }}
                  >
                    <strong> Timestamp </strong>{" "}
                  </TableCell>{" "}
                  <TableCell
                    align="left"
                    className={classes.tabelCell1}
                    style={{
                      width: "15%",
                    }}
                  >
                    <strong> User </strong>{" "}
                  </TableCell>{" "}
                  <TableCell
                    align="left"
                    className={classes.tabelCell1}
                    style={{
                      width: "61%",
                    }}
                  >
                    <strong> Description </strong>{" "}
                  </TableCell>{" "}
                </TableRow>{" "}
              </TableHead>{" "}
              <TableBody>
                {" "}
                {displayRows.map((row, index) => (
                  <LogsRow
                    key={index}
                    row={row}
                    index={index}
                    open={open}
                    setOpen={setOpen}
                  />
                ))}{" "}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: rowHeight * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />{" "}
                  </TableRow>
                )}{" "}
              </TableBody>{" "}
              <TableFooter>
                <TableRow>
                  <TablePagination
                    colSpan={6}
                    count={rows.length}
                    rowsPerPageOptions={rowsPerPageOptions}
                    labelRowsPerPage=""
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />{" "}
                </TableRow>{" "}
              </TableFooter>{" "}
            </Table>{" "}
          </TableContainer>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default LogsHome;
